import { render } from "./MeyaChat.vue?vue&type=template&id=682e9587"
import script from "./MeyaChat.vue?vue&type=script&lang=js"
export * from "./MeyaChat.vue?vue&type=script&lang=js"
script.render = render

export default script